import { Component, ViewEncapsulation } from "@angular/core";
import { Router, NavigationStart } from "@angular/router";
import { AuthService } from "../../services/auth/auth.service";

@Component({
  standalone: false,
    selector: "cage",
    templateUrl: "./cage.component.html",
    styleUrls: ["./cage.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class CageComponent {
    public enableNav = true;
    public enableFooter = true;
    public isLogged = false;
    public isLoginPage = false;

    constructor(
        private router: Router,
        private authService: AuthService,
    ) {
        this.isLogged = this.authService.isAuthenticated();
        this.isLoginPage = this.matchesLogin(this.router.url);
        router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.isLogged = this.authService.isAuthenticated();
                this.isLoginPage = this.matchesLogin(event.url);
                this.enableNav =
                    !event.url.includes("/success_forgot/") &&
                    !event.url.includes("/videochat/") &&
                    !event.url.startsWith("/call/incoming/");

                this.enableFooter =
                    !event.url.includes("/videochat/");
            }
        });
    }

    private matchesLogin(url: string): boolean {
        return (url ?? "").split("?")[0].split("#")[0].replace(/\/$/, "").endsWith("/login");
    }
}
